import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
} from 'components/shadcn/ui/dialog';
import { Button } from 'components/shadcn/ui/button';
import GeneralPolicyContent from './GeneralPolicyContent';

const HGPrivacyPolicy = ({ open, close, setAccountType }) => {
    const accept = () => {
        sessionStorage.setItem('privacyPolicyAccepted', 'true');
        const type = sessionStorage.getItem('signupAccountType');
        setAccountType(type);
        close();
    };

    return (
        <Dialog open={open} onOpenChange={close}>
            <DialogContent className="max-w-3xl">
                <DialogHeader>
                    <DialogTitle className="text-2xl text-foreground">
                        Privacy Policy
                    </DialogTitle>
                </DialogHeader>
                <GeneralPolicyContent />
                <DialogFooter className="mt-6 flex justify-center">
                    <Button
                        variant="outline"
                        className="mr-4 w-24 text-foreground"
                        onClick={accept}
                    >
                        Accept
                    </Button>
                    <Button
                        variant="outline"
                        className="w-24 text-foreground"
                        onClick={close}
                    >
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default HGPrivacyPolicy;
